import { render } from "./IBNode.vue?vue&type=template&id=76b135bc"
import script from "./IBNode.vue?vue&type=script&lang=js"
export * from "./IBNode.vue?vue&type=script&lang=js"
script.render = render

export default script